import 'css-chunksrc/client/pages/documentsPage/documentsPage/document/styles.scss';export default {
  "document": "_document_zgn06_1",
  "icon": "_icon_zgn06_35",
  "name": "_name_zgn06_40",
  "size": "_size_zgn06_46",
  "avatar": "_avatar_zgn06_52",
  "creationDate": "_creationDate_zgn06_57",
  "contextualMenu": "_contextualMenu_zgn06_62",
  "editIcon": "_editIcon_zgn06_74",
  "removeIcon": "_removeIcon_zgn06_78",
  "loader": "_loader_zgn06_82"
};